import { Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { Box, Stack } from "@mui/system";
import React from "react";
import { useDropzone } from "react-dropzone";
import { DropzoneContent } from "../../../pages/treatment-plan/styles";
import { StyledLabel } from "../InputLabel";
import { FileHelper, FileLabel, StyledDropzone } from "./styles";
import { Grid } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
const LargeDropzone = ({ label, onDrop, current, handleRemoveFile }) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDropAccepted: (files) => {
      onDrop(files);
    },
  });

  return (
    <Stack direction="row" spacing={2}>
      <StyledDropzone {...getRootProps()}>
        <input {...getInputProps()} />
        <DropzoneContent>
          <FileLabel>{label}</FileLabel>
          <FileHelper>Drag or drop files</FileHelper>
        </DropzoneContent>
      </StyledDropzone>

      <Box sx={{ margin: 2, width: "90%" }}>
        <StyledLabel>Selected Files</StyledLabel>
        <Box sx={{ paddingTop: 1 }}>
          {current ? (
            current.map((file, idx) => (
              <Grid container height={"20px"}>
                <Grid item xs={7}>
                  <Typography
                    key={JSON.stringify(file)}
                    sx={{ color: grey[600] }}
                  >
                    {file.file.name}
                  </Typography>
                </Grid>

                <Grid item xs={3}>
                  <FontAwesomeIcon
                    icon={faTrash}
                    onClick={() => handleRemoveFile(idx)}
                    style={{
                      cursor: "pointer",
                      color: "#808080",
                      width: "14px",
                      height: "14px",
                      "&:hover": {
                        backgroundColor: "red",
                      },
                    }}
                  />
                </Grid>
              </Grid>
            ))
          ) : (
            <Typography sx={{ color: grey[700] }}>No files</Typography>
          )}
        </Box>
      </Box>
    </Stack>
  );
};

export default LargeDropzone;
